import { allTrackers } from "app/services/track/track";

import createActivationAgentTrackingService from "./factory";

const activationAgentTrackingService = createActivationAgentTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default activationAgentTrackingService;
